import React from "react";
import AgTechHeaderUserDetail from "../../../../../integrations/users/widgets/AgTechHeaderUserDetail";
import { AgTechButtonProps, AgTechButton } from "../../../../Buttons/AgTechButtons";
import AgTechActionPane from "../../../../Headers/AgTechActionPane";
import { AgTechWebApplication } from "../../../../../application/AgTechWebApplication";

const AgTechWebAppHeader = (props: { app: AgTechWebApplication }) => {
    const appHeaderContent = props.app.structure.header?.content;

    return (
        <AgTechActionPane
            customization={{
                padLastElement: true
            }}
            elements={[
                appHeaderContent && appHeaderContent(props.app),
                <AgTechHeaderUserDetail />,
                <AgTechWebAppHeaderButton
                    icon={'bi bi-grid-3x3-gap-fill'}
                />
            ]}
        />
    )
};

export const AgTechWebAppHeaderButton = (props: AgTechButtonProps) => {
    return (
        <AgTechButton
            {...props}
            classes={`px-1 border-0 text-detail !bg-transparent hover:bg-transparent hover:text-highlight ${props.classes ?? ''}`}
            iconClasses={`mx-0 mr-[0px] !text-xl ${props.iconClasses ?? ''}`}
        />
    )
}

const AgTechWebAppHeaderMemo = React.memo(AgTechWebAppHeader);

export default AgTechWebAppHeaderMemo;